// extracted by mini-css-extract-plugin
export default {"shareBox":"shareBox--YmUmY","nftList":"nftList--zxoiH","item":"item--RrS7G","buttonGroup":"buttonGroup--ZE9eO"};